import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CloseIcon from '@icons/CloseIcon';
import WarningIcon from '@icons/WarningIcon';
import { BodySmall, ButtonNoStyles } from '@styled';
import colors from '@general/colors';

export const notificationTypes = {
    INFO: 'info',
    ERROR: 'error',
};

const ComponentContainerStyled = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
`;

const IconContainerStyled = styled.div`
    display: flex;
    margin-top: 2px;
`;

const WarningContainerStyled = styled.div`
    display: flex;
`;

const DismissibleContainerStyled = styled.div`
    display: flex;
`;

const CloseButtonStyled = styled(ButtonNoStyles)`
    display: flex;
`;

const NotificationBanner = ({
    children,
    dismissible = false,
    handleDismiss,
    notificationType = notificationTypes.INFO,
}) => {
    return (
        <ComponentContainerStyled
            className={classNames({
                'bg-bright-sun-tint': notificationType === notificationTypes.INFO,
                'bg-cinnebar-tint': notificationType === notificationTypes.ERROR,
            })}
        >
            <WarningContainerStyled>
                <IconContainerStyled>
                    <WarningIcon />
                </IconContainerStyled>

                <BodySmall as="div" style={{ marginLeft: '10px' }}>
                    {children}
                </BodySmall>
            </WarningContainerStyled>

            {dismissible ? (
                <DismissibleContainerStyled>
                    <CloseButtonStyled
                        onClick={() => {
                            handleDismiss();
                        }}
                    >
                        <CloseIcon fill={colors.black} />
                    </CloseButtonStyled>
                </DismissibleContainerStyled>
            ) : null}
        </ComponentContainerStyled>
    );
};

NotificationBanner.propTypes = {
    children: PropTypes.node.isRequired,
    dismissible: PropTypes.bool,
    handleDismiss: PropTypes.func,
    notificationType: PropTypes.string,
};

export default NotificationBanner;
